import React from "react";
import Layout from "components/Layout";

const Contact = () => {
  return (
    <Layout>
      <section>This is the Contact page</section>
    </Layout>
  );
};

export default Contact;
